import { render, staticRenderFns } from "./transfer_deposit.vue?vue&type=template&id=2d0abc2c&"
import script from "./transfer_deposit.vue?vue&type=script&lang=js&"
export * from "./transfer_deposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports